/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Already_Counted_TodayInputs */

const vi_stocktake_already_counted_today = /** @type {(inputs: Stocktake_Already_Counted_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay đã kiểm loại lô này rồi. Nếu cần kiểm lại, vui lòng hủy phiếu cũ trước.`)
};

/**

* @param {Stocktake_Already_Counted_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_already_counted_today = /** @type {((inputs?: Stocktake_Already_Counted_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Already_Counted_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_already_counted_today(inputs)
});